import { useContext, useEffect, useState } from "react";
import useLocations from "../../../api/hooks/useLocations";
import { days_of_the_week } from "../../../consts/misc";
import MainContext from "../../../context/MainContext";
import { Location } from "../../../interfaces";
import {
  getCurrentMonth,
  getCurrentWeek,
  getDayIndex
} from "../../../utils/getMethods";

const LocationRow = (props: any) => {
  const { setLocationSelected, setOnEdit, locationToggler } = props;

  const { model, refresh } = useContext(MainContext);

  const { RESPONSES, RESULTS, CTAs } = useLocations();

  const [locationsFetched, setLocationsFetched] = useState<Location[]>([]);

  useEffect(() => {
    if (model) {
      CTAs.getListAll(model.id);
    }
  }, [refresh]);

  useEffect(() => {
    /* console.log(RESPONSES.getListAllResponse, RESULTS.getListAllResult); */
    if (RESPONSES.getListAllResponse?.ok) {
      setLocationsFetched(RESULTS.getListAllResult.locations);
    }
  }, [RESPONSES.getListAllResponse]);

  const onClickHandler = (location: Location | null) => {
    setLocationSelected(location);
    setOnEdit(true);
    locationToggler.toggle();
  };

  const dayColumns = getCurrentWeek(props.startDate, props.endDate).map(
    (date, key) => {
      const index = getDayIndex(date.getDay());
      const currentDay = days_of_the_week[index!];
      let locationResult = "";
      let locationSelectedTemp: Location | null = null;
      const sortedList = locationsFetched.sort(
        (a, b) =>
          new Date(a.starting_date).getTime() -
          new Date(b.starting_date).getTime()
      );
      sortedList.map((location: Location) => {
        const dayOfTheWeek = new Date(
          `${
            getCurrentMonth(date).word
          } ${date.getDate()},${date.getFullYear()}`
        ).getTime();
        const startingDay = new Date(
          `${getCurrentMonth(new Date(location.starting_date)).word} ${new Date(
            location.starting_date
          ).getDate()},${new Date(location.starting_date).getFullYear()}`
        ).getTime();
        const endingDay = new Date(
          `${getCurrentMonth(new Date(location.ending_date)).word} ${new Date(
            location.ending_date
          ).getDate()},${new Date(location.ending_date).getFullYear()}`
        ).getTime();
        if (dayOfTheWeek <= endingDay && dayOfTheWeek >= startingDay) {
          locationResult = locationResult.concat(" " + location.location);
          locationSelectedTemp = location;
        }
      });
      return (
        <p
          key={key}
          className="location"
          onClick={() => onClickHandler(locationSelectedTemp)}
        >
          {locationResult}
        </p>
      );
    }
  );

  return (
    <div className="location-row">
      <p className="locationRef">Location</p>
      {dayColumns}
    </div>
  );
};
export default LocationRow;
